export const name = 'Auth'

import { useMainStore } from '@/stores/main'
import * as Server from '@/services/Server'

export async function login(data) {
  const store = useMainStore()
  const path = store.apiPath.login

  return Server.post(path, data)
    .then(response => {
      console.log("Auth.login response", response.data)
      setToken(response.data.data.access_token)
      setUser(response.data.data.user)
      return response
    })
    
}

export async function register(data) {
  const store = useMainStore()
  const path = store.apiPath.register
  return Server.post(path, data)
    .then(response => {
      return response.data.access_token
    })
}

// export async function permissions() {
//   const store = useMainStore()
//   const path = store.apiPath.permissions
//   return Server.get(path)
//     .then(response => {
//       window.Laravel.jsPermissions = response.data;
//       store.setProperty('permissions', response.data.permissions)
//       store.setProperty('roles', response.data.roles)
//     })
// }

export async function setPermissions(jsPermissions) {
  if (!jsPermissions){
    return
  }
  const store = useMainStore()
  store.setProperty('permissions', jsPermissions.permissions ?? [])
  store.setProperty('roles', jsPermissions.roles ?? [])
}

export async function logout(data) {
  const store = useMainStore()
  const path = store.apiPath.logout
  return Server.post(path, data)
    .finally(() => {
      clientLogout()
    })
}

export function clientLogout()
{
  const store = useMainStore()
  revokeToken()
  store.permissions = []
  store.roles = []
  store.unsetProperty('user', 'auth')
}

export async function forgotPassword(data) {
  const store = useMainStore()
  const path = store.apiPath.forgot_password
  return Server.post(path, data)
}

export async function resetPassword(data) {
  const store = useMainStore()
  const path = store.apiPath.reset_password
  return Server.post(path, data)
}

export function setToken(token) {
  const store = useMainStore()
  store.setProperty('token', token, 'auth')
}

export function revokeToken() {
  const store = useMainStore()
  store.unsetProperty('token', 'auth')
}

export function setUser(user) {
  const store = useMainStore()
  store.setProperty('user', user, 'auth')
}

export function getToken() {
  const store = useMainStore()
  return store.token
}

export function isAuthenticated() {
  const store = useMainStore()
  return store.token != null
}

export function getUser() {
  const store = useMainStore()
  return store.user
}

export function getUserId() {
  const store = useMainStore()
  return store.user?.id
}

export function isVerified() {
  return true
}

export function isTournamentOwned(tournament) {
  const userId = getUserId()
  return userId && tournament.user_id == userId
}
